import PropTypes from 'prop-types';

// ----------------------------------------------------------------------

Logo.propTypes = {
  sx: PropTypes.object,
  className: PropTypes.string,
};

// Renders both light and dark variants; CSS (the `.dark` class on <html>,
// set by src/hooks/use-theme.ts and the inline FOUC script in index.html)
// toggles which one is visible. Pure-HTML <img> instead of MUI Box because
// the Box wrapper kept both images visible under some HMR/specificity
// conditions — plain markup is more predictable here.
//
// `sx` is still accepted as an inline-style fallback for existing MUI
// consumers that pass dimensions through it (Login.js, Register.js, etc.).
export default function Logo({ sx, className }) {
  const base = `${import.meta.env.BASE_URL}static`;
  const style = { width: 175, height: 48, ...sx };
  const cls = (visibility) =>
    `${visibility}${className ? ` ${className}` : ''}`;

  return (
    <>
      <img
        src={`${base}/logo.svg`}
        alt="Betterfield"
        className={cls('block dark:hidden')}
        style={style}
      />
      <img
        src={`${base}/logo-dark.svg`}
        alt="Betterfield"
        className={cls('hidden dark:block')}
        style={style}
      />
    </>
  );
}
